// extracted by mini-css-extract-plugin
module.exports = {"activityMenu":"widget-demo--activityMenu--35dUs","mainMenu":"widget-demo--mainMenu--6VZ6_","menuExit":"widget-demo--menuExit--1OCrn","exitButton":"widget-demo--exitButton--1IP6S"};